import { ThumbsDown, ThumbsUp } from 'lucide-react';
import { useId, useState } from 'react';
import { Button } from '../ui/button';

/** "Was this helpful?" — admins see the least helpful articles (task 27a). */
export function HelpFeedback({ slug }: { slug: string }) {
  const [state, setState] = useState<'ask' | 'comment' | 'done'>('ask');
  const [helpful, setHelpful] = useState<boolean | null>(null);
  const [comment, setComment] = useState('');
  const commentId = useId();
  const send = async (h: boolean, c?: string) => {
    await fetch('/api/help/feedback', { method: 'POST', body: JSON.stringify({ slug, helpful: h, comment: c }) });
    setState('done');
  };
  if (state === 'done') return <p className="text-sm text-muted-foreground">Thanks for the feedback.</p>;
  return (
    <div className="space-y-2 rounded-md border bg-surface p-3 text-sm">
      {state === 'ask' && (
        <div className="flex items-center gap-2">
          <span>Was this helpful?</span>
          <Button size="sm" variant="outline" onClick={() => send(true)}>
            <ThumbsUp /> Yes
          </Button>
          <Button
            size="sm"
            variant="outline"
            onClick={() => {
              setHelpful(false);
              setState('comment');
            }}
          >
            <ThumbsDown /> No
          </Button>
        </div>
      )}
      {state === 'comment' && (
        <form
          className="space-y-2"
          onSubmit={e => {
            e.preventDefault();
            send(helpful ?? false, comment);
          }}
        >
          <label htmlFor={commentId} className="block">
            What was missing? (optional)
          </label>
          <textarea
            id={commentId}
            value={comment}
            onChange={e => setComment(e.target.value)}
            rows={2}
            className="w-full rounded-md border border-input bg-surface p-2"
          />
          <Button size="sm" type="submit">
            Send
          </Button>
        </form>
      )}
    </div>
  );
}
